<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI THANH TOÁN</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT THANH TOÁN</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT THANH TOÁN</h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <div class="info">
            <span class="text-thong-tin-form-thanh-toan"
              ><i class="fas fa-info-circle"></i> THÔNG TIN ĐƠN HÀNG</span
            >
          </div>
          <b-row>
            <b-col md="6">
              <el-form-item label="Mã đơn hàng" prop="don_hang.ma">
                <el-input
                  v-model="mData.dataForm.don_hang.ma"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="6">
              <el-form-item label="Tiền đơn hàng" prop="don_hang.tien">
                <el-input
                  v-model="mData.dataForm.don_hang.tien"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <div class="info">
            <span class="text-thong-tin-form-thanh-toan"
              ><i class="fas fa-info-circle"></i> THÔNG TIN DÒNG HỌ</span
            >
          </div>
          <b-row>
            <b-col md="3">
              <el-form-item label="Tên dòng họ" prop="dong_ho.ten">
                <el-input
                  v-model="mData.dataForm.dong_ho.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item
                label="Tên người thanh toán"
                prop="nguoi_thanh_toan_id"
              >
                <el-input
                  v-model="mData.dataForm.nguoi_thanh_toan"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số điện thoại" prop="nguoi_thanh_toan_id">
                <el-input
                  v-model="mData.dataForm.nguoi_thanh_toan_phone"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Email" prop="nguoi_thanh_toan_id">
                <el-input
                  v-model="mData.dataForm.nguoi_thanh_toan_email"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <div class="info">
            <span class="text-thong-tin-form-thanh-toan"
              ><i class="fas fa-info-circle"></i> THÔNG TIN THANH TOÁN</span
            >
          </div>
          <b-row>
            <b-col md="8">
              <b-row>
                <b-col md="3">
                  <el-form-item label="Trạng thái" prop="trang_thai">
                    <el-select
                      v-model="mData.dataForm.trang_thai"
                      placeholder="Select"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in mData.trangThai"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item
                    label="Phương thức"
                    prop="phuong_thuc_thanh_toan.ten"
                  >
                    <el-input
                      v-model="mData.dataForm.phuong_thuc_thanh_toan.ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      @input="forceUpdateUI"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Phí khách" prop="phi.khach">
                    <el-input
                      v-model="mData.dataForm.phi.khach"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      @input="forceUpdateUI"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Thời điểm tạo" prop="thoi_diem.tao">
                    <el-date-picker
                      v-model="mData.dataForm.thoi_diem.tao"
                      type="datetime"
                      placeholder="Chọn ngày"
                      format="dd-MM-yyyy"
                      :disabled="mData.viewMode == 'detail'"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="4">
              <div class="money text-tong-tien-form-thanh-toan">
                <div class="money__title">TỔNG TIỀN</div>
                <div class="money__content">
                  <p>{{ mData.dataForm.tien_thanh_toan }} VNĐ</p>
                </div>
              </div>
              <p class="text-money" v-if="moneyText">
                Bằng chữ: {{ moneyText }} đồng
              </p>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <!-- <el-button
              type="primary"
              @click="fn_addCongKhai()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            > -->
            <!-- <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              disabled
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            > -->
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormThanhToan";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        trangThai: MethodService.copyObject(DataForm.trangThai),
      },
      ten_goiDV_array: [],
      moneyText: "",
    };
  },
  methods: {
    async fn_initForm() {
      try {
        const response = await mushroom.thanh_toan.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,don_hang,dong_ho,nguoi_thanh_toan_id,phuong_thuc_thanh_toan,phi,tien_thanh_toan,trang_thai,thoi_diem",
        });
        response.result.nguoi_thanh_toan = "";
        response.result.nguoi_thanh_toan_phone = "";
        response.result.nguoi_thanh_toan_email = "";

        this.mData.dataForm = await this.fn_changeData(response.result);
        console.log("Thanh toán chi tiết:", this.mData.dataForm);
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async fn_changeData(data) {
      data.don_hang.tien = data.don_hang.tien
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      data.tien_thanh_toan = data.tien_thanh_toan
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      // data.dien_thoai = "0" + data.dien_thoai.slice(2, 11);
      let resData = await this.fn_getThongTinNguoiThanhToan(
        data.nguoi_thanh_toan_id
      );
      data.nguoi_thanh_toan = resData.ten.ho_ten;
      data.nguoi_thanh_toan_phone = resData.thong_tin_lien_lac.dien_thoai;
      data.nguoi_thanh_toan_phone =
        "0" + data.nguoi_thanh_toan_phone.slice(2, 11);
      data.nguoi_thanh_toan_email = resData.thong_tin_lien_lac.email;
      this.moneyText = MethodService.numberToVND(data.tien_thanh_toan);
      return data;
    },

    async fn_getThongTinNguoiThanhToan(id) {
      try {
        const response = await mushroom.nguoi_dung.listAsync({
          filters: ["id=" + id],
        });
        return response.result[0];
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // quay lại danh sách Thuê bao
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    // if (this.$router.currentRoute.name == "ThemThueBao") {
    //   this.mData.viewMode = "create";
    //   this.loading = false;
    // }
    if (this.$router.currentRoute.name == "ChiTietThanhToan") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatThanhToan") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
.info {
  margin: 20px 0px 10px 0;

  span {
    padding: 7px 15px;
    border-radius: 5px;
  }
  span.khuyen-mai {
    background: #e5b715;
  }
  span.tong-gia {
    background: #f56c6c;
  }
}
.text-money {
  margin-top: 10px;
  font-style: italic;
  color: rgb(31, 2, 68);
  font-size: 13px;
}
.money {
  padding: 5px 10px;
  border-radius: 5px;
  &__title {
    border-bottom: 1px solid rgb(221, 221, 221);
    font-size: 18px;
  }
  &__content {
    font-size: 20px;
    padding: 10px 0;
    text-align: center;
    font-weight: 600;
  }
}
</style>
